import {Box, Button, Typography} from '@mui/material';
import lifeplaceImageDesktop from 'presentation/assets/images/lifeplace-image-desktop.webp';
import lifeplaceDesktop from 'presentation/assets/images/lifeplace-desktop.svg';

import {Loading} from 'presentation/components/Loading/Loading';
import React from 'react';

import {translations} from 'presentation/translations-new';
import {StyledBox} from './styles';
import {BannerProps} from '../types';
import {useHostName} from 'presentation/hooks';

const {
	lifeplace: {banner},
} = translations['pt-br'].privateFlow.perks;

export const DesktopBanner = ({isFetching, handleClick}: BannerProps) => {
	const {isNotredameSaude} = useHostName();
	return (
		<StyledBox style={{backgroundImage: `url("${lifeplaceDesktop}")`}}>
			<Box display="flex" alignItems="center" justifyContent="center" gap="40px">
				<Box>
					<Typography variant="h5" fontWeight={700} mb={0.5}>
						{banner.title}
					</Typography>

					<Typography variant="body1" color="text.primary" maxWidth={512}>
						{isNotredameSaude
							? banner.description.part1Notredame
							: banner.description.part1Gndi}
						<strong>{banner.description.part2}</strong>
						{banner.description.part3}
					</Typography>

					<Button
						variant="contained"
						size="medium"
						sx={{mt: 3, width: '132px'}}
						endIcon={isFetching ? <Loading color="inherit" size={16} /> : null}
						disabled={isFetching}
						onClick={handleClick}>
						{banner.button}
					</Button>
				</Box>

				<img src={lifeplaceImageDesktop} alt={banner.imageAlt} height={190} />
			</Box>
		</StyledBox>
	);
};
